import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__workspace } from '@shared/dto/+workspace/workspace_entity/DTO__workspace';
import { STATE__workspace } from '../STATE__workspace';

export const local_workspace_upsert = (payload: DTO__workspace[]): PayloadAction<DTO__workspace[]> => ({
  type: ENUM__redux_action.WORKSPACE_UPSERT,
  payload,
});

export const init_local_workspace_upsert = (state: STATE__workspace, action: PayloadAction<DTO__workspace[]>) => {
  if (action.payload.is_empty()) return;

  for (let workspace of action.payload) {
    if (state.workspace_current._id == workspace._id) {
      state.workspace_current = workspace;
    }

    state.workspaces_map.set(workspace._id, workspace);
  }

  //refresh map to trigger re-render
  state.workspaces_map = new Map(state.workspaces_map);
};
